module.exports = __webpack_public_path__ + "assets/6b69b0801117a75d0c2ef4ba8aaec353.png";